import React from 'react';

function Header() {
  return (
    <div className="text-center" style={{ marginTop: "50px" }}>
      <h1>Actarus Project</h1>
    </div>
  );
}

export default Header;
